import{jsx as _jsx}from"react/jsx-runtime";import React,{useCallback}from"react";import{ButtonInternal}from"./ButtonInternal.js";/**
	 * If specified, the button will be disabled until the user confirms the
	 * action.
	 *//**
 * A styled <button> element.
 *
 * @param props The HTML props for the button element.
 * @returns A styled button element.
 */export const Button=props=>{const{confirmText,onClick,...rest}=props;const handleClick=useCallback(e=>{if(confirmText){if(confirm(confirmText)){onClick?.(e)}}else{onClick?.(e)}},[onClick,confirmText]);return /*#__PURE__*/_jsx(ButtonInternal,{Element:"button",onClick:handleClick,...rest})};